import {
  Tabs,
  TabsHeader,
  TabsBody,
  Tab,
  TabPanel,
} from "@material-tailwind/react";
import TaskMonitor from "../../components/message/TaskMonitor";
import DeviceMonitor from "../../components/message/DeviceMonitor";
import TimeLineMonitor from "../../components/message/TimeLineMonitor";


export default function Monitor() {
  const data = [
    {
      label: "Task",
      value: "task",
      component: <TaskMonitor/>
    },
    {
      label: "TimeLine",
      value: "timeline",
      component: <TimeLineMonitor/>
    },
    {
      label: "Device",
      value: "device",
      component: <DeviceMonitor/>
    }
  ];

  return (
    <>
      <Tabs value="task">
        <TabsHeader>
          {data.map(({label,  value }) => (
            <Tab key={value} value={value}>
              {label}
            </Tab>
          ))}
        </TabsHeader>
        <TabsBody>
          {data.map(({ value, component }) => (
            <TabPanel key={value} value={value}>
              {component}
            </TabPanel>
          ))}
        </TabsBody>
      </Tabs>
    </>
  )
}
